import { posthog, enablePosthog, disablePosthog } from './analytics'

export { enablePosthog, disablePosthog }

export default {
  track({ event, userId, properties = {}, context = {} }) {
    if (!posthog.__loaded) {
      return;
    }

    if (!event) {
      console.error('Analytics error: Event name is required for tracking');
      return;
    }

    if (userId) {
      posthog.identify(userId);
    }
    
    const eventProperties = { ...properties };
    
    if (context.groupId) {
      eventProperties.$groups = {
        account: context.groupId
      };
    }
    
    if (context.accountId) {
      eventProperties.accountId = context.accountId;
    }
    
    try {
      posthog.capture(event, eventProperties);
    } catch (error) {
      console.error('Analytics error:', error);
    }
  },
  
  identify(userId, traits = {}) {
    if (!posthog.__loaded) {
      return;
    }

    if (!userId) {
      return;
    }
    
    try {
      posthog.identify(userId, traits);
    } catch (error) {
      console.error('Analytics error:', error);
    }
  },
  
  group(groupId, traits = {}) {
    if (!posthog.__loaded) {
      return;
    }

    if (!groupId) {
      return;
    }
    
    try {
      posthog.group('account', groupId, traits);
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }
}